import { toast as sonnerToast } from "sonner";
import { Toast, type ToastType } from "./Toast";

function createToast(type: ToastType) {
  return (message: string) => sonnerToast.custom((id) => <Toast id={id} type={type} message={message} />);
}

/** Custom toast functions with headless styling. */
export const toast = {
  success: createToast("success"),
  error: createToast("error"),
  info: createToast("info"),
  warning: createToast("warning"),
  loading: createToast("loading"),
  dismiss: sonnerToast.dismiss,
};
